import {
    MOTORCYCLE_MODEL_SUCCESS,
    MOTORCYCLE_MODEL_ERROR,
    MOTORCYCLE_MODEL_START
} from "Constant/index.js"

const initialState = {
    loading: false,
    data: [],
};
export default function MotorcycleModelReducer(state = { ...initialState }, action) {
    switch (action.type) {
        case MOTORCYCLE_MODEL_START:
            return {
                ...state,
                loading: true,
            };
        case MOTORCYCLE_MODEL_SUCCESS:
            return {
                ...state,
                data: action.payload,
                loading: false,
            };
        case MOTORCYCLE_MODEL_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };
        default:
            return state;
    }
}

